import defaultAttributes from '../defaultAttributes';

const TrendingDown = [
  'svg',
  defaultAttributes,
  [
    ['polyline', { points: '23 18 13.5 8.5 8.5 13.5 1 6' }],
    ['polyline', { points: '17 18 23 18 23 12' }],
  ],
];

export default TrendingDown;
